import type { ComponentPropsWithoutRef } from 'react'

import { cn } from '@/utils'

export const FigureLabel = ({
  className,
  ...props
}: ComponentPropsWithoutRef<'p'>) => (
  <p
    className={cn('text-[13px] font-medium text-ink-subtle', className)}
    {...props}
  />
)
